import { Input, SimpleChanges } from "@angular/core";
import { Component, OnChanges, OnInit } from "@angular/core";
import { AppService } from "../../../../../src/app/app.service";
import { IceNavService } from "../../../../icemedx-lib/src/components/ice-nav/ice-nav.service";
import { PaymentMethods } from "../../../../icemedx-lib/src/components/models/icesettings";
import { userTypes } from "../../../../icemedx-lib/src/login/login.config";
import { assetjournal } from "../../../../icemedx-lib/src/models/accounting/assetjournal";
import { payment } from "../../../../icemedx-lib/src/models/accounting/payment";
import { patient } from "../../../../icemedx-lib/src/models/domain/patient";
import { IceTypes } from "../../../../icemedx-lib/src/models/icetypes";
import { AccountingService } from "../../../../icemedx-lib/src/services/accounting/accounting.service";
import { DomainService } from "../../../../icemedx-lib/src/services/domain/domain.service";
import { Iceutility } from "../../../../icemedx-lib/src/services/iceutility";

@Component({
  selector: 'app-listofpayments',
  templateUrl: './listofpayments.component.html',
  styleUrls: ['./listofpayments.component.scss']
})
export class ListOfPaymentsComponent implements OnInit, OnChanges {
  @Input() medicalServiceKeys: string[] = [];
  payments: payment[] = [];
  hasAccess: boolean = true;

  payAdjTypes = [
    { value: IceTypes.coa_types.coaAR, name: "Service Payment" },
    { value: IceTypes.coa_types.coaCoInsuranceAR, name: "Co-Insurance Payment" },
    { value: IceTypes.coa_types.coaDeductibleAR, name: "Deductible Payment" },
    { value: IceTypes.coa_types.coaDiscount, name: "Discount" },
    { value: IceTypes.coa_types.coaClaimAdjustment, name: "Claim Adjuments" },
    { value: IceTypes.coa_types.coaDisallowedAdjustment, name: "Disallowed Adjustment" },
    { value: IceTypes.coa_types.coaContractualObligationsAdjustment, name: "Contractual Obligations Adjustment" },
    { value: IceTypes.coa_types.coaCorrectionandReversalsAdjustment, name: "Correction / Reversals Adjustment" },
  ];

  constructor(private acctSvc: AccountingService, private appSvc: AppService, private domainSvc: DomainService) { }

  ngOnInit() {
    /// TODO: confirm the permission for listing the payments
    let feaAccess = this.appSvc.getPermission(userTypes.USER_FEATURES.ufSuperBill).default_access;
    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      this.hasAccess = false;

      setTimeout(_ => {
        this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
      });
    }
  }

  ngOnChanges(changeObj: SimpleChanges) {
    if (Iceutility.isdefined(changeObj.medicalServiceKeys) && Iceutility.isdefined(changeObj.medicalServiceKeys.previousValue)) {
      if (changeObj.medicalServiceKeys.currentValue !== changeObj.medicalServiceKeys.previousValue) {
        this.medicalServiceKeys = changeObj.medicalServiceKeys.currentValue;
        if (this.hasAccess) {
          this.getPayments();
        }
      }
    }
  }

  private getPayments() {
    this.acctSvc.getJournals(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "", "", IceTypes.JournalType.jtAsset, IceTypes.coa_types.coaAsset, this.medicalServiceKeys, IceTypes.coa_types.coaDeductibleAR)
      .subscribe(data => {
        if (data != null) {
          console.log(data);
          let credit = 0.0,
            journalKeys: string[] = [];

          for (let ijrnl = 0; ijrnl < data[0].length; ijrnl++) {
            let jrnl: assetjournal = data[0][ijrnl],
              coatyp = Iceutility.toLong(jrnl.coa_type),
              srctype = Iceutility.toLong(jrnl.src_type);

            if (coatyp == IceTypes.coa_types.coaAR
              || coatyp == IceTypes.coa_types.coaCoPayAR
              || coatyp == IceTypes.coa_types.coaCoInsuranceAR
              || coatyp == IceTypes.coa_types.coaDeductibleAR)
              credit += Iceutility.toDouble(jrnl.credit);

            if (srctype == IceTypes.SourceType.srcPayment) {
              journalKeys.push(jrnl.src_key);
            }
          }

          this.acctSvc.getPayments(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), journalKeys)
            .subscribe((payments: payment[]) => {
              if (Iceutility.isdefined(payments)) {
                let paymentsToShow = [];

                for (let iPayment = 0; iPayment < payments.length; iPayment++) {
                  let tempPayment: payment = payments[iPayment][0],
                    payAdjTyp = "",
                    payType = "N/A", amount = 0, description = "",
                    payment = {};

                  if (!paymentsToShow.find(p => p.key === tempPayment.payment_key)) {
                    if (tempPayment.payment_response === PaymentMethods.pmCash.toString()) {
                      payType = "Cash";
                    }

                    if (Iceutility.isdefined(tempPayment.SERVICES) && tempPayment.SERVICES.length > 0) {
                      let service = tempPayment.SERVICES[0];
                      amount = service.amount;
                      description = service.description;

                      let payAdjTypFound = this.payAdjTypes.filter(p => p.value == Iceutility.toLong(service.coa_type));
                      if (payAdjTypFound.length > 0) {
                        payAdjTyp = payAdjTypFound[0].name;
                      }
                      else {
                        payAdjTyp = AccountingService.getCoaType(service.coa_type);
                      }
                    }

                    payment = {
                      key: tempPayment.payment_key,
                      pay_date: Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(tempPayment.pay_date)),
                      cash_coa_type: Iceutility.toLong(tempPayment.cash_coa_type) == IceTypes.coa_types.coaNone ? "N/A" : AccountingService.getCoaType(tempPayment.cash_coa_type),
                      coa_type: payAdjTyp,
                      payType,
                      amount,
                      description,
                      reference_num: tempPayment.reference_num
                    };
                    this.setResponsibleParty(payment, tempPayment.trans_account);
                    paymentsToShow.push(payment);
                  }
                }
                this.payments = paymentsToShow;
              }
            });
        }
      });
  }

  private setResponsibleParty(payment, transAccount) {
    try {
      this.domainSvc.getPatient(transAccount, this.appSvc.getCurrentAccount()).subscribe(
        data => {
          if (data != null && data.length > 0) payment.responsibleParty = (this.appSvc.getPatientName(<patient>data[0]) + " (Payer)");
        });
    } catch (ex) { console.log(ex) }
  }
}
